/** @file facingWords: a body azimuth in words, as the fill-slots guide says it (0 = toward the viewer). */

const CARDINAL: Record<number, string> = {
  0: 'toward the viewer', 90: 'turned to face screen-left', 180: 'the back', 270: 'turned to face screen-right',
  45: 'three-quarter view, turned toward screen-left', 135: 'three-quarter back view, turned toward screen-left',
  225: 'three-quarter back view, turned toward screen-right', 315: 'three-quarter view, turned toward screen-right',
};

/** `toward the viewer (0 deg)`, `turned to face screen-left (90 deg)`, `the back (180 deg)`; `rest-pose facing` when unknown. */
export function facingWords(azimuthDeg: number | undefined): string {
  if (azimuthDeg === undefined || !Number.isFinite(azimuthDeg)) return 'facing as in the rest pose';
  const deg = Math.round((((azimuthDeg % 360) + 360) % 360) * 10) / 10;
  const named = CARDINAL[deg === 360 ? 0 : deg];
  if (named !== undefined) return `${named} (${String(deg === 360 ? 0 : deg)} deg)`;
  const side = deg < 180 ? 'screen-left' : 'screen-right';
  return `turned ${String(deg < 180 ? deg : Math.round((360 - deg) * 10) / 10)} deg toward ${side}`;
}
